export const delete_SplitButton = "nAd";
export const flagUnflag_SplitButton = "oAd";
export const junk_SplitButton = "pAd";
export const newMessage_SplitButton = "qAd";
export const respond_SplitButton = "rAd";
export default {delete_SplitButton,flagUnflag_SplitButton,junk_SplitButton,newMessage_SplitButton,respond_SplitButton};